export const searchFormColumns = (ctx) => {
  return [
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      type: 'select',
      name: '合同状态',
      prop: 'contractStatus',
      options: ctx.contractStatusList,
    },
    {
      name: '合作伙伴名称',
      prop: 'partnerName',
      type: 'searchTableSpec',
      searchType: 'supplier',
      extraData: {
        companyCode: ctx.userInfo.companyCode,
        departmentCode: ctx.userInfo.departmentCode,
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
    },
    {
      name: '合作伙伴编码',
      prop: 'partnerCode',
      type: 'searchTableSpec',
      searchType: 'supplier',
      isMultiple: true,
      currentValue: ctx.query.partnerCode ? ctx.query.partnerCode : null,
      changeMethod: 'changeMethod',
    },
    // {
    //   name: '关联合同',
    //   prop: 'superviseContractNo',
    //   type: 'input',
    // },
    {
      name: '租赁期限',
      prop: 'leaseTerm',
      type: 'input',
    },
    {
      name: '租赁日期从',
      prop: 'leaseDateFrom',
      type: 'date',
      formate: 'yyyy-MM-DD',
    },
    {
      name: '租赁日期至',
      prop: 'leaseDateUnit',
      type: 'date',
      formate: 'yyyy-MM-DD',
    },
    {
      name: '空间类型',
      prop: 'spaceType',
      type: 'select',
      options: ctx.spaceTypeList,
    },
    {
      prop: 'paperContractNo',
      name: '纸质合同号',
      type: 'input',
    },
  ];
};

export const baseColumnListDefault = [
  { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
  // { type: 'seq', width: '50', title: 'table.index', fixed: 'left' },
  // {
  //   type: 'seq',
  //   title: 'table.index',
  //   visible: true,
  //   width: '80',
  // },
  {
    field: 'partnerName',
    title: '合作伙伴名称',
    width: 120,
  },
  {
    field: 'partnerCode',
    title: '合作伙伴编号',
    width: 120,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    width: 120,
  },
  {
    field: 'paperContractNo',
    title: '纸质合同号',
    width: 120,
  },
  {
    field: 'contractStatus',
    title: '合同状态',
    width: 120,
  },
  {
    field: 'signDate',
    title: '签约日期',
    width: 120,
  },
  {
    field: 'signPlace',
    title: '签约地点',
    width: 120,
  },
  {
    field: 'signPerson',
    title: '签约人',
    width: 120,
  },
  {
    field: 'leaseDateFrom',
    title: '租赁开始日期',
    width: 120,
  },
  {
    field: 'leaseDateUnit',
    title: '租赁结束日期',
    width: 120,
  },
  {
    field: 'leaseTerm',
    title: '租赁期限',
    width: 120,
  },
  {
    field: 'spaceType',
    title: '空间类型',
    width: 120,
  },
  {
    field: 'remark',
    title: '备注',
    width: 120,
  },
];
